import { post } from 'app/utils/axios/kheti'
import { FarmerDetails } from '../models/farmer'
import { AxiosError } from 'axios'

interface Response {
  message: string
  user: FarmerDetails | null
}

const addFarmerDetails = async (body: Record<string, any>) => {
  try {
    const url = `/farmer-360/v1/farmer/add`
    return await post<Response>(url, body)
  } catch (e) {
    const data: any = (e as AxiosError).response?.data
    return {
      message:
        data.phone_number[0] || 'Something went wrong. Please try again later.',
      user: null,
    } as Response
  }
}

export default addFarmerDetails
